import { connect } from 'react-redux';
import * as metaSelectors from 'redux-modules/meta/selectors.js';
import * as placementActions from 'redux-modules/placements/actions.js';
import * as placementSelectors from 'redux-modules/placements/selectors.js';
import * as resumesActions from 'redux-modules/resumes/actions.js';
import * as resumesSelectors from 'redux-modules/resumes/selectors.js';
import CandidateCV from 'components/ProjectCandidateCV';

function mapStateToProps(state, ownProps) {
  return {
    cv: resumesSelectors.selectResume(state, ownProps.candidateId),
    indexedMeta: metaSelectors.selectIndexedMeta(state),
    project: placementSelectors.selectPlacement(state, ownProps.placementId),
    loading: resumesSelectors.selectSyncState(state) || placementSelectors.selectSyncState(state)
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onInit: () => {
      dispatch(resumesActions.loadMngCandidateCV(ownProps.candidateId));
      dispatch(placementActions.loadPlacements());
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CandidateCV);
